import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { PURCHASE_TYPE, purchaseData } from "helper/constant";
import Button from "component/ui/Button";
import PageHeading from "component/ui/PageHeading";
import { GrStreetView } from "react-icons/gr";
import { toast } from "react-toastify";
import { MdArrowBackIos, MdArrowForwardIos } from "react-icons/md";
import RatingStar from "component/ui/Star";
import Textarea from "component/ui/Textarea";
import { useDispatch } from "react-redux";
import { addProductRatingReviews } from "store/slice/booking";

export default function PurchaseDetailPage() {
  const [ratingData, setRatingData] = useState({});
  const [hover, setHover] = useState(0);
  const [selectedRating, setSelectedRating] = useState(0);
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const data =
    location?.state?.productData?.length > 0
      ? location?.state?.productData[0]
      : null;

  // ✅ Find correct item
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    setActiveIndex(0);
  }, [id]);

  if (!data) {
    return <div className="p-6">Purchase not found</div>;
  }

  const images = data ? data?.productImage : [];

  const downloadFile = () => {
    if (!location?.state?.orderInvoiceUrl)
      return toast.error("Something went wrong!");
    const link = document.createElement("a");
    link.href = location?.state?.orderInvoiceUrl;
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const handleRating = () => {
    const request = {
      language: "en",
      ratingType: 2,
      rating: ratingData?.rating,
      description: ratingData?.description,
      reviewToUserId: data?.userId,
      productId: data?._id,
    };
    dispatch(addProductRatingReviews(request,setRatingData));
  };
  return (
    <div className="min-h-screen bg-gray-100 md:p-6 px-3 py-6 container mx-auto">
      <PageHeading title={"Purchase Details"} />

      <div className="min-h-screen bg-white rounded-2xl shadow md:p-6 p-3">
        <div className="flex md:flex-row flex-col gap-8">
          {/* LEFT: IMAGE SLIDER */}
          <div className="border rounded-lg md:w-96">
            <div className="relative rounded-xl overflow-hidden">
              <img
                src={images[activeIndex]}
                alt="Product"
                className="w-full h-80 object-contain"
              />

              <button
                onClick={() =>
                  setActiveIndex(
                    activeIndex === 0 ? images?.length - 1 : activeIndex - 1
                  )
                }
                className="absolute md:left-3 left-0 top-1/2 -translate-y-1/2 bg-blue-100 w-8 h-8 rounded-full shadow"
              >
                {/* ◀ */}
                <MdArrowBackIos className="w-8 mx-auto" />
              </button>

              <button
                onClick={() =>
                  setActiveIndex(
                    activeIndex === images.length - 1 ? 0 : activeIndex + 1
                  )
                }
                className="absolute md:right-3 right-0 top-1/2 -translate-y-1/2 bg-blue-100 w-8 h-8 rounded-full shadow"
              >
                {/* ▶ */}
                <MdArrowForwardIos className="w-8 mx-auto" />
              </button>
            </div>
          </div>

          {/* RIGHT: DETAILS */}
          <div>
            <div className="flex items-center justify-between">
              <h1 className="text-xl">{data?.title}</h1>
            </div>

            <p className="text-gray-600 text-sm my-3 line-clamp-3">
              {data?.description}
            </p>

            <div className="flex flex-col gap-4 mb-2">
              <div className="flex gap-2">
                <p className="text-sm text-gray-500 w-40">Location : </p>
                <p className="text-sm font-medium flex gap-2">
                  {data?.location?.address}
                  {data?.location?.coordinates?.length > 0 && (
                    <a
                      href={`https://www.google.com/maps?q=${data?.location?.coordinates[1]},${data?.location?.coordinates[0]}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600"
                    >
                      <GrStreetView className="h-5 w-5 cursor-pointer text-highlight" />
                    </a>
                  )}
                </p>
              </div>

              <div className="flex gap-2">
                <p className="text-sm text-gray-500 w-40">
                  Purchase Country :{" "}
                </p>
                <p className="text-sm font-medium">{data?.productCountry}</p>
              </div>

              <div className="flex gap-2">
                <p className="text-sm text-gray-500 w-40">Creation Date :</p>
                <p className="text-sm font-medium">
                  {data?.creationDate &&
                    new Date(data?.creationDate).toLocaleDateString()}
                </p>
              </div>

              <div className="flex gap-2">
                <p className="text-sm text-gray-500 w-40">Price :</p>
                <p className="text-sm font-semibold">₹{data?.price}</p>
              </div>
            </div>
            <div
              className="underline cursor-pointer mb-6 text-highlight"
              onClick={() => {
                setRatingData((rating) => ({
                  ...rating,
                  isOpen: true,
                }));
              }}
            >
              Add Review/Rating
            </div>

            <div className="flex gap-4">
              <Button onClick={downloadFile}>Download Invoice</Button>
              <Button
                variant="secondary"
                className="px-6"
                onClick={() => navigate(-1)}
              >
                Back
              </Button>
            </div>
          </div>
        </div>
        {/* rating /review dialog */}
        {ratingData?.isOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
            <div className="bg-white rounded-2xl w-[380px] shadow-xl animate-in fade-in zoom-in-95">
              {/* Header */}
              <div className="px-6 pt-6 ">
                <h2 className="text-xl font-semibold text-gray-900">
                  {location?.state?.purchaseType &&
                    PURCHASE_TYPE[location?.state?.purchaseType]}{" "}
                  Rating
                </h2>
              </div>

              {/* Stars */}
              <div className="flex justify-center gap-3 my-6">
                {[1, 2, 3, 4, 5].map((star) => (
                  <RatingStar
                    key={star}
                    filled={star <= (hover || ratingData?.rating)}
                    onClick={() =>
                      setRatingData((rating) => ({
                        ...rating,
                        rating: star,
                      }))
                    }
                    onMouseEnter={() => setHover(star)}
                    onMouseLeave={() => setHover(0)}
                  />
                ))}
              </div>

              <div className="p-2">
                <Textarea
                  value={ratingData?.description}
                  onChange={(e) =>
                    setRatingData((rating) => ({
                      ...rating,
                      description: e.target.value,
                    }))
                  }
                  placeholder="Write your feedback here..."
                />
              </div>

              {/* Footer */}
              <div className="flex  gap-3 px-6 py-4 bg-gray-50 rounded-b-2xl">
                <Button
                  fullWidth
                  variant="secondary"
                  onClick={() => setRatingData({})}
                >
                  Cancel
                </Button>

                <Button fullWidth disabled={!ratingData?.rating} onClick={handleRating}>
                  Submit
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
